var render, staticRenderFns
import script from "./RenderProps.vue?vue&type=script&lang=ts&"
export * from "./RenderProps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e8d735",
  null
  
)

export default component.exports